function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'light-gray-heather': 'rgb(179, 179, 179)','birch': 'rgb(241, 241, 202)','dark-gray-heather': 'rgb(128, 128, 128)','natural-heather': 'rgb(210, 180, 140)','kentucky-blue-heather': 'rgb(191, 233, 247)','blue-nights-heather': 'rgb(48, 51, 110)','insignia-blue': 'rgb(36, 80, 140)','sage': 'rgb(131, 172, 131)','anchor-gray': 'rgb(96, 95, 95)','ivory-chiffon': 'rgb(253, 253, 237)','night-navy': 'rgb(16, 16, 96)','quiet-shade-gray': 'rgb(128, 128, 128)','quiet-shade-heather': 'rgb(177, 177, 177)','vintage-indigo': 'rgb(76, 89, 118)','charcoal-gray': 'rgb(78, 78, 78)','charcoal-gray-heather': 'rgb(92, 90, 90)','light-blue': 'rgb(172, 199, 230)','steel-gray': 'rgb(135, 135, 135)','stone': 'rgb(212, 189, 158)','anthracite': 'rgb(105, 104, 104)','cool-gray': 'rgb(172, 172, 172)','blacktop-heather': 'rgb(97, 95, 95)','deep-blue-heather': 'rgb(0, 0, 128)','navy-geo-diamond': 'rgb(40, 32, 153)','anchor-grey-geo-diamond': 'rgb(128, 128, 128)','glacier': 'rgb(218, 218, 218)','sky': 'rgb(222, 247, 255)','sahara': 'rgb(210, 180, 140)','river-blue-navy': 'rgb(0, 0, 128)','graphite': 'rgb(191, 191, 191)','french-blue': 'rgb(189, 200, 242)','blue-nights': 'rgb(0, 0, 128)','black-heather': 'rgb(0, 0, 0)','court-blue': 'rgb(5, 88, 155)','light-blue': 'rgb(172, 199, 230)','midnight-navy': 'rgb(40, 32, 153)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
